import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fr from 'vuetify/src/locale/fr';
import en from 'vuetify/src/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: {
      fr,
      en,
    },
    current: 'en',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#707070',
        secondary: '#c0c0c0',
        accent: '#82BFB1',
        error: '#FF5252',
        info: '#21F396',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
});
